import {$generateHtmlFromNodes} from '@lexical/html';
import {createEditor} from 'lexical';
import {ImageNode} from '@common/components/forms/rich-text-form-field/nodes/image-node';
import {LinkNode} from '@lexical/link';
import {ListItemNode, ListNode} from '@lexical/list';
import {HeadingNode, QuoteNode} from '@lexical/rich-text';
import {DashListNode} from '@common/components/forms/rich-text-form-field/nodes/dash-list-node';

/**
 * Konwertuje JSON z Lexical edytora na HTML
 * @param jsonString - JSON string z Lexical edytora
 * @returns HTML string
 */
export function convertLexicalJsonToHtml(jsonString: string): string {
    if (!jsonString) return '';

    try {
        // Stwórz editor z konfiguracją
        const editor = createEditor({
            nodes: [
                ImageNode,
                LinkNode,
                ListNode,
                ListItemNode,
                HeadingNode,
                QuoteNode,
                DashListNode
            ],
            theme: {
                paragraph: "rich-text-p",
                heading: {
                    h1: "rich-text-h1",
                    h2: "rich-text-h2",
                },
                text: {
                    bold: "rich-text-bold",
                    italic: "rich-text-italic",
                    underline: "rich-text-underline",
                },
                list: {
                    nested: {
                        listitem: "rich-text-li",
                    },
                    ol: "rich-text-ol",
                    ul: "rich-text-ul",
                    listitem: "rich-text-li",
                },
                quote: "rich-text-blockquote",
                image: "rich-text-img",
            }
        });

        const editorState = editor.parseEditorState(jsonString);

        return editorState.read(() => $generateHtmlFromNodes(editor, null));
    } catch (error) {
        console.error('Error converting Lexical JSON to HTML:', error);
        return '';
    }
}
